import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../../common/types';
import { Panel } from '../../../components/primitives/Panel';
import { fanReleaseMessages } from './overviewMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole card; each part uses its own slice of it */
import styles from './FanReleasePanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface FanReleaseCardProps {
  /** A plan chip or a status pill on the right of "Your fans". */
  badge?: React.ReactNode;
  title?: string;
  body?: string;
  /** A state with no action (too old): the title is grey. */
  isOff?: boolean;
  children?: React.ReactNode;
}

/** The frame of every state of "Send to your subscribers" (design presave-subscriptions d2). */
const FanReleaseCardComponent: React.FC<FanReleaseCardProps> = ({ badge, title, body, isOff = false, children }) => {
  const intl = useIntl();

  return (
    <Panel as="section" pad className={clsx(styles.card, isOff && styles.off)} data-testid="release-fan-release">
      <div className={styles.eyebrow}>
        <span>{intl.formatMessage(fanReleaseMessages.eyebrow)}</span>
        {badge}
      </div>
      {title !== undefined && <h4 className={styles.title}>{title}</h4>}
      {body !== undefined && <p className={styles.body}>{body}</p>}
      {children}
    </Panel>
  );
};

export const FanReleaseCard = TypedMemo(FanReleaseCardComponent);
